import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { useEffect, useState } from "react";
import { removeToken, setRoomAssignment } from "store/user/slice";
import SyncClient, { SyncMap } from "twilio-sync";

export function useSyncRoom(roomUid: string, syncClient?: SyncClient) {
  const dispatch = useDispatch();
  const { username } = useSelector((s: RootState) => s.user);
  const [participantsInArea, setParticipantsInArea] = useState<string[]>([]);

  useEffect(() => {
    async function setup() {
      if (syncClient) {
        const updateParticipantsInArea = async function (
          guestMap: SyncMap,
          username: string
        ) {
          const guests = await guestMap.getItems();
          try {
            const user: any = await guestMap.get(username);
            dispatch(setRoomAssignment(user.data.area));
            const pia = guests.items
              .filter((g: any) => g.data.area === user.data.area)
              .map((pia: any) => pia.data.name);
            setParticipantsInArea(pia);
          } catch (e) {
            // Eat the "resource not found" error
            if (e.code !== 54201) {
              throw e;
            }
          }
        };

        const guestMap = await syncClient.map(roomUid + "-guests");
        guestMap.on("itemAdded", async (_) =>
          updateParticipantsInArea(guestMap, username)
        );
        guestMap.on("itemUpdated", async (_) =>
          updateParticipantsInArea(guestMap, username)
        );
        guestMap.on("itemRemoved", async (event) => {
          if (event.key === username) {
            dispatch(removeToken());
            return;
          }

          updateParticipantsInArea(guestMap, username);
        });

        updateParticipantsInArea(guestMap, username);
      }
    }

    setup();
  }, [dispatch, username, syncClient, roomUid]);

  return {
    participantsInArea,
  };
}
